module.exports = __webpack_public_path__ + "img/92-thickbox_default.4cd119d1.jpg";